<template>
  <div class="footer">
    <!-- <span v-if="language == 'zh-CN'">
      <a href="javascript:;" @click="toggleLanguage('en-US')">English</a> | 简体中文
    </span>
    <span v-if="language == 'en-US'">
      English | <a href="javascript:;" @click="toggleLanguage('zh-CN')">简体中文</a>
    </span> -->
    <span class="copyright">©{{date}} MLDIE</span>
    <span class="foot-icons">
      <!-- <a-tooltip>
        <template slot='title'>
          github
        </template>
        <a class="gray"><a-icon type="github" /></a>|
      </a-tooltip>
      <a-tooltip>
        <template slot='title'>
          mail
        </template>
        <a class="gray"><a-icon type="mail" /></a>|
      </a-tooltip> -->
        <a-tooltip>
          <template slot='title'>
            Home
          </template>
          <router-link to="/" class="gray"><a-icon type="home" theme="filled" /></router-link>
        </a-tooltip><span class="split">|</span>
        <a-tooltip>
          <template slot='title'>Github</template>
          <a class="gray" target="_blank" href="https://github.com/MLDIE"><a-icon type="github" /></a>
        </a-tooltip><span class="split">|</span>
        <a-tooltip>
          <template slot='title'>Twitter</template>
          <a class="gray" target="_blank" href="https://twitter.com/MLDIED"><a-icon type="twitter" /></a>
        </a-tooltip><span class="split">|</span>
        <a-tooltip>
          <template slot='title'>FriendLinks</template>
          <router-link to="/friendlink" class="gray"><a-icon type="link" /></router-link>
        </a-tooltip>
    </span>
  </div>
</template>

<script>
// import { Icon } from 'ant-design-vue';

export default {
  components: {
    // 'a-icon': Icon,
    // 'a-tooltip': Tooltip,
  },
  data() {
    return {
      date: (new Date()).getFullYear()
    }
  },
  methods: {
    toggleLanguage(lang) {
      localStorage.setItem('lang', lang);
      this.$i18n.locale = lang;
    }
  },
  computed: {
    language() {
      return this.$i18n.locale;
    },
  }
}
</script>

<style scoped>
.footer {
  margin: 3rem 0 3rem 0;
  padding: 0 0 3rem 0;
}
.foot-icons a {
  color: #555;
  cursor: pointer;
  display: inline-block;
  /* padding: 0 8px; */
}
.foot-icons a:hover {
  color: #1890ff;
}
.copyright {
  color: #999;
  font-size: .87rem;
  float: right;
}
.split {
  display: inline-block;
  padding: 0 8px;
}
</style>

